import React, {Fragment} from 'react';
import TarifarioYDisponibilidad from 'components/nuevoTarifario/TarifarioYDisponibilidad';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import DatosDemograficos from 'components/nuevoTarifario/DatosDemograficos';
import DatosDelCanal from 'components/nuevoTarifario/DatosDelCanal';
import PasoAPasoHorizontal from 'components/pasoAPasoHorizontal';
import { Card, CardContent, Typography } from '@mui/material';
import Cobertura from 'components/nuevoTarifario/Cobertura';
import { useSelector } from 'react-redux';

const NuevoCanal= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, ...rest}) => {
  const {activeStep, numberStep, datosDelCanal, tarifarioYDisponibilidad, datosDemograficos, cobertura,} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

  const obtenerContenidoDePasos = (step) => {
    switch (step) {
      case 0:
        // return <Cobertura activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} cobertura={cobertura}/>
        // return <DatosDemograficos activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelCanal={datosDelCanal} tarifarioYDisponibilidad={tarifarioYDisponibilidad} cobertura={cobertura} datosDemograficos={datosDemograficos} tituloModalDeConfirmacion="un nuevo canal" tarifario="del canal" />
        // return <TarifarioYDisponibilidad activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} tarifarioYDisponibilidad={tarifarioYDisponibilidad} />
        return <DatosDelCanal activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelCanal={datosDelCanal} />
      case 1:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 2:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 3:
        return renderizarAlSiguientePaso(rest.steps[step])
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const renderizarAlSiguientePaso = (currentStep) => {
    switch(currentStep?.id) {
      case 1:
        return <TarifarioYDisponibilidad activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} tarifarioYDisponibilidad={tarifarioYDisponibilidad} />
      case 2:
        return <Cobertura activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} cobertura={cobertura}/>
      case 3:
        return <DatosDemograficos activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelMedio={datosDelCanal} tarifarioYDisponibilidad={tarifarioYDisponibilidad} cobertura={cobertura} datosDemograficos={datosDemograficos} tituloModalDeConfirmacion="un nuevo canal" tarifario="del canal" tipoMedio="television" nitEmpresa={datosDeEmpresa.nit} />
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const cerrarPantallaCompleta = () => handleClose(true);

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={cerrarPantallaCompleta}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          <Card>
              <CardContent>
                  <PasoAPasoHorizontal
                      cerrarPantallaCompleta={cerrarPantallaCompleta}
                      steps={rest.steps}
                      obtenerContenidoDePasos={obtenerContenidoDePasos}
                      activeStepProp={activeStep}
                      numberStepProp={numberStep}
                      showButtonStepper={false}
                  />
              </CardContent>
          </Card>
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default NuevoCanal;